





























































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import { GetBanjiOptions, GetQaList, DelQa } from "@/request/common";
import ReadQa from "@/components/qa/read-qa.vue";
@Component({
  components: {
    ReadQa,
  },
})
export default class Name extends mixins(listMixin) {
  private banjis: any = [];
  private data: any = [];
  private wendaData: any = {};
  private ifShowWenda: any = false;
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private get user() {
    return this.$store.state.user;
  }
  private openWenda(item: any) {
    this.wendaData = JSON.parse(JSON.stringify(item));
    this.ifShowWenda = true;
  }
  private replySure(e: any) {
    this.ifShowWenda = false;
    this.getList();
  }
  private goZhishidian(item: any) {
    this.$router.push({
      path: "/main/teacher/textbook-resources",
      query: {
        data: JSON.stringify(item),
        type: "问答",
      },
    });
  }
  private deleteOne(item: any) {
    this.$confirm("您确定要删除该数据么？", "删除", {
      customClass: "commonConfirm",
      confirmButtonClass: "iconfont icon-anniu4 confirmSure",
      cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
    })
      .then(() => {
        const loading = this.$loading({
          lock: true,
          text: "加载中……",
          spinner: "el-icon-loading",
          customClass: "loadClass",
          background: "rgba(255, 255, 255, 0.7)",
        });
        const params: any = {
          data: {
            wenda_id: item.wenda_id,
          },
        };
        DelQa(this, params, loading)
          .then((res: any) => {
            loading.close();
            this.$message.success("删除成功");
            if (this.data.length === 1 && this.filters.current_page !== 1) {
              this.filters.current_page--;
            }
            this.getList();
          })
          .catch(() => {
            loading.close();
          });
      })
      .catch((e) => {
        console.log("取消了");
      });
  }
  getList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params = {
      状态: this.filters["状态"],
      banji_id: this.filters["班级"],
      search: this.filters.search,
      order_key: this.filters.sort_field,
      order_value: this.filters.sort_value,
      current_page: this.filters.current_page,
      page_count: this.filters.page_count,
    };
    GetQaList(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.data = res.data;
        this.filters.total_count = res.total_count;
        this.filters.total_page = res.total_page;
        if (this.data.length > 0) {
          this.ifShowEmpty = false;
        } else {
          this.ifShowEmpty = true;
        }
      })
      .catch(() => {
        loading.close();
      });
  }
  private getBanjis() {
    GetBanjiOptions(this).then((res: any) => {
      this.banjis = res;
    });
  }
  mounted() {
    this.filters.sort_field = "update_time";
    this.getList();
    this.getBanjis();
  }
}
